module.exports = __webpack_public_path__ + "img/1.b4dbd58.png";